const EmptyState = ({ icon = "pi pi-inbox", message, actionLabel, onAction }) => (
  <div className="admin-list__empty">
    <i className={icon} aria-hidden="true" />
    <p>{message}</p>
    {actionLabel && onAction && (
      <button type="button" className="admin-link-btn" onClick={onAction}>
        {actionLabel}
      </button>
    )}
  </div>
);

export default EmptyState;
